import Journeys from '@/pages/journeys';
import { LastWorkspaceResolver, LazyPage, WorkspaceInAppSettingsPage } from '@/routes/-components';
import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { ProtectedRoute } from '@/services/router/components/protected-route';

const NO_ACCESS_MESSAGE =
  "You do not have permission to view workspace settings. If you'd like access, let an Admin know.";

/**
 * The rollout flag is read first, so an account without it keeps the embedded app on every URL
 * shape, `/workspaces/last` included; then the workspace and its access.
 */
export function InAppSettingsRouteView() {
  const isMigrated = useFeatureFlag(AccountFeatureFlag.InAppSettingsMigration);

  if (!isMigrated) {
    return <Journeys />;
  }

  return (
    <LastWorkspaceResolver>
      <ProtectedRoute
        permission="journeys/workspace_settings/view"
        allowReadOnlyMasqAccess={true}
        redirectTo="/settings"
        errorMessage={NO_ACCESS_MESSAGE}
      >
        <LazyPage>
          <WorkspaceInAppSettingsPage />
        </LazyPage>
      </ProtectedRoute>
    </LastWorkspaceResolver>
  );
}
